<template>
	<div class="the-
	navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

		<div class="text-right leading-tight hidden sm:block">
			<p class="font-semibold">{{ $store.state.auth.user.first_name }} {{ $store.state.auth.user.last_name }}</p>
			<small>{{ $t($store.state.auth.role) }}</small>
		</div>

		<vs-dropdown vs-custom-content vs-trigger-click :fixed="true" class="cursor-pointer">

			<div class="con-img ml-3">
				<img v-if="$store.state.auth.user.photo" key="onlineImg" :src="$store.state.auth.user.photo" alt="user-img"
					 width="40" height="40" class="rounded-full shadow-md cursor-pointer block"/>
				<svg v-else width="40" height="40" x="0" y="0" class="" style="opacity: 1;"><defs><clipPath id="cp_daa29dc4"><path d="M20 0 L20 0 C30.9 0 40 9.1 40 20 L40 20 C40 30.9 30.9 40 20 40 L20 40 C9.1 40 0 30.9 0 20 L0 20 C0 9.1 9.1 0 20 0 Z"></path></clipPath></defs><svg x="0" y="0" width="40" height="40" clip-path="url(#cp_daa29dc4)" style="overflow: hidden;"><image x="0" y="0" height="40" width="40" preserveAspectRatio="none" xlink:href="https://storage.moqups.com/repo/vtToXvAXig/_clipboard/viVtUvH345.jpg"></image></svg><path d="M20 0 L20 0 C30.9 0 40 9.1 40 20 L40 20 C40 30.9 30.9 40 20 40 L20 40 C9.1 40 0 30.9 0 20 L0 20 C0 9.1 9.1 0 20 0 Z" stroke-width="0.25" stroke="rgb(0,0,0)" stroke-dasharray="none" fill="none"></path></svg>
			</div>

			<vs-dropdown-menu vs-custom-dropdown :fixed="true" class="vx-navbar-dropdown">
				<ul style="min-width: 9rem">

					<li class="custom-menu-item flex py-2 px-4 cursor-pointer">
						<feather-icon icon="UserIcon" svgClasses="w-4 h-4"/>
						<router-link to="/profile">
							<span class="ml-2 flex">{{ $t('profile') }}</span>
						</router-link>
					</li>

					<vs-divider class="m-1"/>

					<li
						class="custom-menu-item flex py-2 px-4 cursor-pointer"
						@click="logout">
						<feather-icon icon="LogOutIcon" svgClasses="w-4 h-4"/>
						<span class="ml-2 flex">{{ $t('logout') }}</span>
					</li>
				</ul>
			</vs-dropdown-menu>
		</vs-dropdown>
	</div>
</template>

<script>
import axios from "@/axios";

export default {
	computed: {
		activeUserInfo() {
			return this.$store.state.AppActiveUser
		}
	},
	async created() {
		try {
			let res = await this.$http.get('/'+this.$store.state.auth.role+'/profile');
			await this.$store.dispatch('updateUserInfo', res.data.data)
		} catch (e) {
			this.$vs.notify({
				title: 'Error',
				text: e.message,
				iconPack: 'feather',
				icon: 'icon-alert-circle',
				color: 'danger'
			})
		}
	},
	methods: {
		async logout() {
			await this.$store.dispatch('logout');
			this.$router.go(0);
		}
	},
}
</script>
